import React from 'react';
import styles from './Pill.module.css';
import { STATUS_KINDS, statusKind } from '../branches/statusConfig';

export default function Pill({ kind, status, dot = false, pulse = false, children }) {
  const resolvedKind = kind ?? statusKind(status);
  const tokens = STATUS_KINDS[resolvedKind] ?? STATUS_KINDS.neutral;

  return (
    <span
      className={styles.pill}
      style={{
        '--pill-bg':     tokens.bg,
        '--pill-fg':     tokens.fg,
        '--pill-border': tokens.bd,
        '--pill-dot':    tokens.dot,
      }}
    >
      {dot && <span className={`${styles.dot} ${pulse ? styles.pulse : ''}`} />}
      {children}
    </span>
  );
}
